import { Button, Form, Input, message } from 'antd';
import { PasswordRecovery } from 'services/RecoveryPassword';
import { requiredRule } from 'utils/forms/validationRules';
import { RecoveryPhoneFormWrapper } from '../style';

function RecoveryCodeForm({ setCurrentStep, setFormData, formData }) {
  const [form] = Form.useForm();

  const onSubmit = async ({ code }) => {
    try {
      const payload = {
        mobile_phone: formData.mobile_phone,
        code,
      };
      const res = await PasswordRecovery.verifyCode(payload);
      if (res) {
        setFormData({ ...formData, ...res.data });
        setCurrentStep(2);
      } else {
        message.error('Не получилось потвердить код');
      }
    } catch (err) {
      message.error('Что-то пошло не так. Попробуйте еще раз');
    }
  };

  return (
    <RecoveryPhoneFormWrapper>
      <Form
        form={form}
        onFinish={onSubmit}
        layout="horizontal"
        requiredMark={false}
        labelCol={{
          span: 5,
        }}
        wrapperCol={{
          span: 24,
        }}
      >
        <h4>Воссстановление пароля</h4>

        <div className="login-form">
          <div className="login-form__inputs">
            <Form.Item name="code" label="Код" rules={[requiredRule]}>
              <Input placeholder="Введите код " allowClear />
            </Form.Item>

            <Form.Item />

            <Form.Item
              wrapperCol={{
                offset: 5,
              }}
            >
              <Button type="primary" htmlType="submit">
                Отправить
              </Button>
            </Form.Item>
          </div>
        </div>
      </Form>
    </RecoveryPhoneFormWrapper>
  );
}

export { RecoveryCodeForm };
